if (!customElements.get('b2b-recommendations')) {
  class B2bRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.b2b-recs__track')) {
        this.setupCarousel();
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }

    load() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const fresh = html.querySelector('b2b-recommendations');
          if (fresh && fresh.innerHTML.trim().length) {
            this.innerHTML = fresh.innerHTML;
            this.setupCarousel();
          } else {
            this.closest('.shopify-section')?.classList.add('hidden');
          }
        })
        .catch((error) => console.error(error));
    }

    setupCarousel() {
      this.track = this.querySelector('.b2b-recs__track');
      this.nav = this.querySelector('.b2b-recs__nav');
      if (!this.track || !this.nav) return;
      this.prev = this.nav.querySelector('[data-dir="-1"]');
      this.next = this.nav.querySelector('[data-dir="1"]');

      this.nav.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-dir]');
        if (!button) return;
        const item = this.track.querySelector('.b2b-recs__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        const visible = Math.max(1, Math.round(this.track.clientWidth / step));
        this.track.scrollBy({ left: Number(button.dataset.dir) * step * visible, behavior: 'smooth' });
      });

      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }

    update() {
      const overflow = this.track.scrollWidth - this.track.clientWidth > 2;
      this.nav.hidden = !overflow;
      if (!overflow) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }

  customElements.define('b2b-recommendations', B2bRecommendations);
}
